import axios from "axios";
import config from "../../config/config";

export interface SubscriptionMine {
  id: string;
  packageId: string;
  packageName?: string | null;
  status: string;
  intervalMonths: number;
  currentPeriodStart: string;
  currentPeriodEnd: string;
  nextBillingAt?: string | null;
  expiresAt?: string | null;
  pastDueSinceUtc?: string | null;
  cancelledAtUtc?: string | null;
}

const axiosClient = axios.create({
  baseURL: `${config.apiBaseUrl}/students/subscriptions`,
  headers: { "Content-Type": "application/json" },
  timeout: config.defaultTimeout,
});

axiosClient.interceptors.request.use((req) => {
  const token = localStorage.getItem("token");
  if (token) req.headers.Authorization = `Bearer ${token}`;
  return req;
});

export async function getMySubscriptions(): Promise<SubscriptionMine[]> {
  const { data } = await axiosClient.get<SubscriptionMine[]>("/mine");
  return data ?? [];
}

export async function cancelSubscription(id: string): Promise<SubscriptionMine> {
  const { data } = await axiosClient.post<SubscriptionMine>(`/${id}/cancel`);
  return data;
}
